<template>
  <div class="fillcontain">
    <search-item
      :stdName="stdName"
      @showDialog="showAddRecordDialog"
      @searchList="getRecordList"
      @batchDelRecord="onBatchDelRecord"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
      >
        <!-- <el-table-column
          width="20"
          v-if="idFlag"
          prop="id"
          label="id"
          align="left"
        ></el-table-column> -->
        <!-- <el-table-column type="selection" align="left"></el-table-column> -->
        <el-table-column prop="courseDate" label="日期" align="left" sortable>
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{
              scope.row.courseDate | filterTime
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="courseTime"
          label="时间"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="classType"
          label="班级类型"
          align="left"
          :filters="this.courseTypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.classType }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="courseHour"
          label="课时"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="courseLocation"
          label="上课地点"
          align="left"
        ></el-table-column>
        <el-table-column
           label="主教练评价"
           prop="coursePerformance">
         </el-table-column>
         <el-table-column
           label="助教评价"
           prop="assRate1">
         </el-table-column>
         <el-table-column
           label="助教评价"
           prop="assRate2">
         </el-table-column>
         <el-table-column
           label="备注"
           prop="remark">
         </el-table-column>
         <el-table-column
           label="学习内容"
           prop="courseNote">
         </el-table-column>
        <el-table-column
          prop="packageName"
          label="课包类型"
          align="left"
        ></el-table-column>
<!--        <el-table-column-->
<!--          prop="coursePackageId"-->
<!--          label="课包类型"-->
<!--          align="left"-->
<!--          :filters="this.coursePackageData"-->
<!--          :filter-method="filterCoursePackage"-->
<!--          filter-placement="bottom-end"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag-->
<!--              v-html="formatterCoursePackage(scope.row)"-->
<!--              disable-transitions-->
<!--              >{{ scope.row.coursePackageId }}</el-tag-->
<!--            >-->
<!--          </template>-->
<!--        </el-table-column>-->
        <!-- <el-table-column prop="coach" label="教练" align="left"></el-table-column> -->
        <el-table-column
          prop="activeName"
          label="活动名称"
          align="left"
        ></el-table-column>
        <!-- <el-table-column
          prop="recordNote"
          label="备注"
          align="left"
        ></el-table-column> -->
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              v-show="ROLE == 1"
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditRecord(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-show="ROLE == 1 && scope.row.courseStatus != 0"
              type="danger"
              icon="delete"
              size="mini"
              @click="onDelRecord(scope.row)"
              >删除</el-button
            >
            <el-button
              v-show="ROLE == 1 && scope.row.courseStatus == 0"
              type="danger"
              icon="delete"
              size="mini"
              @click="onDelRecord(scope.row)"
              >取消预约</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="删除课堂记录" :visible.sync="clockInDialogShow9">
        <el-form ref="appointmentRecordDate" :model="appointmentRecordDate">
          <el-form-item required label="删除原因" :label-width="formLabelWidth">
            <el-input
                    placeholder="请输入删除原因"
                    :rows="2"
                    type="text"
                    v-model="appointmentRecordDate.remark"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow9 = false">取 消</el-button>
          <el-button type="primary" @click="doDelRecord()"
          >确 定</el-button
          >
        </div>
      </el-dialog>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addRecordDialog.show"
        :isShow="addRecordDialog.show"
        :dialogRow="addRecordDialog.dialogRow"
        :stdname="addRecordDialog.stdname"
        :courseType="addRecordDialog.courseType"
        @getRecordList="getRecordList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addRecordDialog";
import { myTime, formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";
import { getFormatCoursePackages } from "@/api/coursepackage";

import {
  getRecordInfo,
  deleteRecord,
  batchDeleteRecord,
  getStdNameByStdId,
} from "@/api/record";
import { getFormatClassTypes } from "@/api/courseType";

export default {
  data() {
    return {
      stdName: "加载中",
      tableData: [],
      coursePackageData: [],
      format_course_package_list: {},
      courseTypeData: [],
      tableHeight: 0,
      loading: false,
      formLabelWidth: "120px",
      clockInDialogShow9: false,
      appointmentRecordDate: {
        remark: "",
        id: "",
      },
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      ROLE: 0,
      multipleSelection: [], //多选的数据
      sortnum: 0,
      format_course_type_list: {},
      addRecordDialog: {
        show: false,
        dialogRow: {},
        stdname: "",
        courseType: "",
      },
      recordData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
    };
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["recordSearch"]),
  },
  filters: {
    filterTime(time) {
      //var dd = myTime(time);
      return formatDateTime(time);
    },
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  mounted() {
    this.addRecordDialog.stdName = this.stdName;
    this.getFormatCoursePackagesList();
    this.getFormatClassTypes();
    this.getStdNameByStdId();
    this.getRecordList();
  },
  methods: {
    /**
     * 格式化状态
     */
    formatterCoursePackage(item) {
      const type = parseInt(item.coursePackageId);
      return this.format_course_package_list[type];
    },
    filterCoursePackage(value, item) {
      const type = parseInt(item.coursePackageId);
      return (
        this.format_course_package_list[value] ==
        this.format_course_package_list[type]
      );
    },
    getFormatCoursePackagesList() {
      console.log("getFormatCoursePackagesList");
      getFormatCoursePackages().then((res) => {
        console.log(res);
        this.coursePackageData = res.data.data.coursePackageData;
        this.format_course_package_list =
          res.data.data.format_course_package_list;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    getStdNameByStdId() {
      const para = Object.assign({}, this.recordSearch);
      console.log(para);
      if (para.stdId != "" && para.stdId != null) {
        getStdNameByStdId(para).then((res) => {
          console.log(res);
          this.stdName = res.data.data.stdName;
        });
      }
    },
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        this.courseTypeData = res.data.data.classTypeDataList;
        this.format_course_type_list = res.data.data.formatClassTypeList;
      });
    },
    getRecordList() {
      const para = Object.assign({}, this.recordData, this.recordSearch);
      getRecordInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.recordData;
      });
    },
    // 显示资金弹框
    showAddRecordDialog(val) {
      this.$store.commit("SET_RECORD_DIALOG_TITLE", val);
      this.addRecordDialog.show = true;
    },
    hideAddFundDialog() {
      this.addRecordDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.recordData.page = val;
      this.getRecordList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.recordData.limit = val;
      this.getRecordList();
    },
    /**
     * 格式化状态
     */
    formatterCourseType(item) {
      const type = parseInt(item.classType);
      return this.format_course_type_list[type];
    },
    filterCourseType(value, item) {
      const type = parseInt(item.classType);

      return (
        this.format_course_type_list[value] ==
        this.format_course_type_list[type]
      );
    },
    // 编辑操作方法
    onEditRecord(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      this.addRecordDialog.dialogRow = { ...row };
      this.addRecordDialog.courseType = this.format_course_type_list[
        parseInt(row.classType)
      ];
      this.showAddRecordDialog();
    },
    onDelRecord(row) {
      this.appointmentRecordDate.remark = ''
      this.clockInDialogShow9 = true;
      this.courseRow = row
      console.log(row)
    },
    // 删除数据
    doDelRecord() {
      console.log(this.courseRow)
      const para = { id: this.courseRow.id,remark: this.appointmentRecordDate.remark };
          let stdname = this.stdName;
          let courseDate = this.courseRow.courseDate;
          let courseTime = this.courseRow.courseTime;
          let courseLocation = this.courseRow.courseLocation;
          let courseType = this.format_course_type_list[
            parseInt(this.courseRow.classType)
          ];
          deleteRecord(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:
                "删除学员(" +
                stdname +
                ")课堂记录操作,课堂日期:" +
                courseDate +
                ",时间:" +
                courseTime +
                ",地点:" +
                courseLocation +
                ",班级类型:" +
                courseType,
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getRecordList();
            this.clockInDialogShow9 = false
          });
    },
    // 删除数据
    onDeleteRecord(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          let stdname = this.stdName;
          let courseDate = row.courseDate;
          let courseTime = row.courseTime;
          let courseLocation = row.courseLocation;
          let courseType = this.format_course_type_list[
            parseInt(row.classType)
          ];
          deleteRecord(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content:
                "删除学员(" +
                stdname +
                ")课堂记录操作,课堂日期:" +
                courseDate +
                ",时间:" +
                courseTime +
                ",地点:" +
                courseLocation +
                ",班级类型:" +
                courseType,
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getRecordList();
          });
        })
        .catch(() => {});
    },
    onBatchDelRecord() {
      // console.log("onbatchdelmember");
      this.$confirm("确认批量删除记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.multipleSelection.map((item) => item.id).toString();
          const para = { ids: ids };
          batchDeleteRecord(para).then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "批量删除成功",
                type: "success",
              });
              this.getRecordList();
            }
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_RECORD_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>